import type { CalculatorMatchSelection } from '@nowscore/core';
import { OFFICIAL_MARKET_ORDER } from '@nowscore/core';
import type { MatchDto } from '../api';
import { LotteryMarketGrid } from './LotteryMarketGrid';

export function LotteryCalculatorMarkets({ match, selection, onChange }: { match: MatchDto; selection?: CalculatorMatchSelection | null; onChange: (selection: CalculatorMatchSelection) => void }) {
  return <section className="official-calculator" aria-label="竞彩五玩法计算器"><div className="official-calculator-head"><div><span className="ai-kicker">官方竞彩计算器</span><h3>五玩法完整盘面</h3></div><span>点击赛果加入复式计算</span></div>
    {OFFICIAL_MARKET_ORDER.map((market) => <LotteryMarketGrid key={market} match={match} market={market} selection={selection} onChange={onChange} />)}
  </section>;
}